import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Button,
} from "reactstrap";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { apiGet, apiPost, apiPut } from "helpers/apiService";
import SafeField from "helpers/SafeField";

const EmailDisclaimerTemplateSingle = () => {
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDisclaimer();
  }, []);

  /* ================= FETCH SINGLE ================= */

  const fetchDisclaimer = async () => {
    try {
      const res = await apiGet("SystemEmailDisclaimerTemplate/allAgent?AgentId=0");

      // API may return array or single object
      const data = Array.isArray(res.data) ? res.data[0] : res.data;

      if (data) setInitialData(data);
    } catch (err) {
      toast.error("Failed to load disclaimer");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SAVE (ADD / UPDATE) ================= */

  const handleSubmit = async (values, { setSubmitting }) => {
    toast.loading("Saving...");

    try {
      if (values.emailDisclaimerTemplateId) {
        // UPDATE
        await apiPut("SystemEmailDisclaimerTemplate", values);
        toast.dismiss();
        toast.success("Updated successfully");
      } else {
        // CREATE
        const payload = {
          systemEmailDisclaimer: values.systemEmailDisclaimer,
          agentId: parseInt(localStorage.getItem("userId")) || 0,
          isActive: true,
        };

        await apiPost("SystemEmailDisclaimerTemplate", payload);
        toast.dismiss();
        toast.success("Saved successfully");
        fetchDisclaimer();
      }
    } catch (err) {
      toast.dismiss();
      toast.error("Save failed");
    } finally {
      setSubmitting(false);
    }
  };

  /* ================= VALIDATION ================= */

  const validationSchema = Yup.object({
    systemEmailDisclaimer: Yup.string().required("Disclaimer is required"),
  });

  if (loading) return null;

  return (
    <Container fluid className="page-content">
      <ToastContainer autoClose={2000} />
        <Row className="mb20">
            <Col xl="12">
                <Breadcrumbs
                    title={"General Settings"}
                    breadcrumbItem={"Email Disclaimer"}
                />
            </Col>
        </Row>  
      <Row>
        <Col xl="12">
          <Card>
            <CardBody>
              

              <Formik
                enableReinitialize
                initialValues={{
                    id: initialData?.id || 0,
                  emailDisclaimerTemplateId:
                    initialData?.emailDisclaimerTemplateId || "",
                  systemEmailDisclaimer:
                    initialData?.systemEmailDisclaimer || "",
                  agentId: initialData?.agentId || parseInt(localStorage.getItem("userId")) || 0,
                  isActive: initialData?.isActive ?? true,
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, handleChange, isSubmitting }) => (
                  <Form>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>System Email Disclaimer *</Label>
                          <SafeField
                            name="systemEmailDisclaimer"
                            as="textarea"
                            rows="5"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.systemEmailDisclaimer &&
                              touched.systemEmailDisclaimer
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <ErrorMessage
                            name="systemEmailDisclaimer"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <Button
                          type="submit"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Save Changes
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailDisclaimerTemplateSingle;
